import { Button } from 'antd';

const ErrorCSV: React.FC = () => (
  <>
    <p>The file must have the title &quot;Issues&quot; and issues must come from one column.</p>
    <Button href="https://www.dropbox.com/s/8rwiae8z6wn030j/issues.jpg?dl=0" type="link" target="_blank">
      See an example
    </Button>
  </>
);

export default ErrorCSV;
